export default {
    title: '產品詳情'
}
